import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from "../../../../toolkit/uicomponent";
import { UIComponentView } from "../../../../toolkit/uicomponentview";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentCSSStyle } from "../../../../toolkit/uicomponentcss";
import { APIFeatures } from "src/com/sixdee/crbtportal/core/util/apifeatures";
import { FlashMessageSubscriptionDetailsViewImpl } from "./flashmessagesubscriptiondetailsview";
import { FlashMessageSubscriptionDetailsAPIModel, FlashMessageSubscriptionDetailsAPIModelImpl } from "./flashmessagesubscriptiondetailsapimodel";
import { FlashMessageSubscriptionDetailsCSSStyleImpl } from "./flashmessagesubscriptiondetailscss";
import { APIModelHandler, APIModel } from "../../../../toolkit/uicomponentapimodel";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { AlertType } from "../../../../toolkit/alert/alerttype";
import { FlashMessageSubscriptionDetailsDto } from "src/com/sixdee/crbtportal/core/dto/flashsubscriptiondetails/flashmessagedetails";
import { FlashMessageDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";

export interface FlashMessageSubscriptionDetailsComponentProps extends UIComponentProps
{

}

export interface FlashMessageSubscriptionDetailsComponentState extends UIComponentState
{
    isStatusActive: boolean;
    isSubscribed: boolean;
    packName: string;
    price: string;
    expiryDate: string;
    isCurrentFlashMessageAvailable: boolean;
    currentFlashMessage: string;
}

export interface FlashMessageSubscriptionDetailsHandler extends UIComponentHandler
{
    onUnSubscribeClicked(): void;
    onStatusChcnge(isChecked: boolean):void;
    onDeleteClick(): void;
}

export class FlashMessageSubscriptionDetailsComponent extends UIComponentImpl<FlashMessageSubscriptionDetailsComponentProps, FlashMessageSubscriptionDetailsComponentState, UIDataModel> implements FlashMessageSubscriptionDetailsHandler
{
    constructor(props: FlashMessageSubscriptionDetailsComponentProps)
    {
        super(props);
        this.state = {isStatusActive: false, isSubscribed: false,currentFlashMessage: "", 
        isCurrentFlashMessageAvailable:false, packName:"", price:"", expiryDate:""};
    }

    componentDidMount()
    {
        // (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showLoader();
        if(this.props.context.getUserContext().getIsLoggedIn())
        {
            (this.getAPIModel() as FlashMessageSubscriptionDetailsAPIModel).getSubscriberDetails();
        }
    }
    
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FlashMessageSubscriptionDetailsViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new  FlashMessageSubscriptionDetailsCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new FlashMessageSubscriptionDetailsAPIModelImpl(applicationContext, apiModelHandler);
    }

    onUnSubscribeClicked(): void
    {
        (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showLoader();
        (this.getAPIModel() as FlashMessageSubscriptionDetailsAPIModel).unsubscribe();
    }
    onStatusChcnge(isChecked: boolean):void
    {
        (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showLoader();
        (this.getAPIModel() as FlashMessageSubscriptionDetailsAPIModel).changeStatus(isChecked);
    }

    onDeleteClick(): void {
        (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showLoader();
        (this.getAPIModel() as FlashMessageSubscriptionDetailsAPIModel).deleteFlashMessage();
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("onSuccess: "+ feature + ", " + JSON.stringify(data) );

        (this.getView() as FlashMessageSubscriptionDetailsViewImpl).dismissLoader(); 
        if(feature === APIFeatures.GET_FLASH_SUBSCRIPTION)
        {
            let subscriptionDetailsDto = (data as FlashMessageSubscriptionDetailsDto);
            this.setState({expiryDate:subscriptionDetailsDto.getExpiryDate(), packName: subscriptionDetailsDto.getPlanName(),
        isSubscribed: subscriptionDetailsDto.getPlanName() !== undefined ? true : false});

            (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showLoader();
            (this.getAPIModel() as FlashMessageSubscriptionDetailsAPIModel).getFlashStatus();
        }
        if(feature === APIFeatures.GET_FLASH_STATUS)
        {
            this.setState({isStatusActive: data === "A" ? true : false});

            (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showLoader();
            (this.getAPIModel() as FlashMessageSubscriptionDetailsAPIModel).getFlashMessage(
                this.getContext().getUserContext().getMsisdn());
        }
        else if(feature === APIFeatures.GET_FLASH_MESSAGE)
        {
           let flashMessageDtos = (data as FlashMessageDto[]);
            this.setState({isCurrentFlashMessageAvailable: flashMessageDtos.length > 0 ? true : false,
                 currentFlashMessage: flashMessageDtos.length > 0 ? flashMessageDtos[0].getStatusMessage() : ""});
        }
        else if(feature === APIFeatures.DELETE_FLASH_MESSAGE)
        {
            this.setState({isCurrentFlashMessageAvailable: false});
            (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showPopup("",this.getContext().getResources().getString(Strings.flash_message_delete_success),AlertType.SUCCESS);
        }
        else if(feature === APIFeatures.SUBSCRIBEUNSUBSCRIBE_FLASH_MESSAGE)
        {
            this.setState({isSubscribed: false});
            (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showPopup("",this.getContext().getResources().getString(Strings.flash_message_unsubscribe_success),AlertType.SUCCESS);
        }
        else if(feature === APIFeatures.PLAYPAUSE_FLASH_MESSAGE)
        {
            this.setState({isStatusActive: data as boolean});
            (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showPopup("",this.getContext().getResources().getString(Strings.flash_message_subscription_status_change_success),AlertType.SUCCESS);
        }
    }
    
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("onfailure: " + feature);
        (this.getView() as FlashMessageSubscriptionDetailsViewImpl).dismissLoader();
        if(feature === APIFeatures.SUBSCRIBEUNSUBSCRIBE_FLASH_MESSAGE)
        {
            this.setState({isSubscribed: true});
            (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showPopup("",description,AlertType.ERROR);
        }
        else if(feature === APIFeatures.PLAYPAUSE_FLASH_MESSAGE)
        {
            (this.getView() as FlashMessageSubscriptionDetailsViewImpl).updatePlayPause();
            (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showPopup("",description,AlertType.ERROR);
        }
        else
        {
            (this.getView() as FlashMessageSubscriptionDetailsViewImpl).showPopup("",description,AlertType.ERROR);
        } 
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagesubscriptiondetails/flashmessagesubscriptiondetailscomponent.tsx